import { Paper } from '@mui/material';
import { useTheme } from '@mui/system';
import React from 'react';

const ElevatedContentCard = ({ children }) => {
      const theme = useTheme();
    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                borderRadius: 2,
                backgroundColor: theme.palette.background.paper,
                transition: 'all 0.3s ease'
            }}
        >
            {children}
        </Paper>
    );
};

export default ElevatedContentCard;